<template>
  <div>
    <div class="d-flex flex-wrap align-items-center gap-2">
      <button v-if="showButton" type="button" class="btn btn-sm btn-white" @click="openPanel">
        <i class="fe fe-sliders me-1"></i>
        Filtros
        <span v-if="chips.length" class="badge bg-primary ms-1">{{ chips.length }}</span>
      </button>
      <span v-for="chip in shownChips" :key="chip.key" class="badge bg-primary-soft chip">
        {{ chip.text }}
        <i class="fas fa-times cursor-pointer ms-1" @click="remove(chip.key)"></i>
      </span>
      <button v-if="showChips && chips.length" type="button" class="btn btn-sm btn-white" @click="clearAll">Limpar tudo</button>
    </div>

    <div v-if="open" class="filter-backdrop" @click="open = false"></div>
    <aside class="filter-drawer" :class="{ 'filter-drawer--open': open }">
      <div class="d-flex align-items-center justify-content-between p-4 border-bottom">
        <h3 class="mb-0">Filtros</h3>
        <i class="fas fa-times text-muted cursor-pointer" @click="open = false"></i>
      </div>
      <div class="p-4 flex-grow-1 overflow-auto">
        <div v-for="field in fields" :key="field.key" class="mb-4">
          <label class="form-label text-muted small mb-1">{{ field.label }}</label>
          <select v-if="field.type === 'select'" class="form-select form-select-sm" v-model="draft[field.key]">
            <option value="">Todos</option>
            <option v-for="o in field.options" :key="o.value" :value="o.value">{{ o.label }}</option>
          </select>
          <div v-else-if="field.type === 'multi'">
            <div v-for="o in field.options" :key="o.value" class="form-check">
              <input class="form-check-input" type="checkbox" :id="`fp_${field.key}_${o.value}`" :value="o.value"
                v-model="draft[field.key]" />
              <label class="form-check-label" :for="`fp_${field.key}_${o.value}`">{{ o.label }}</label>
            </div>
          </div>
          <input v-else :type="field.type" :min="field.type === 'number' ? 0 : null"
            class="form-control form-control-sm" v-model="draft[field.key]" />
        </div>
      </div>
      <div class="p-4 border-top d-flex gap-2">
        <button type="button" class="btn btn-white w-50" @click="resetDraft">Limpar</button>
        <button type="button" class="btn btn-primary w-50" @click="apply">Aplicar</button>
      </div>
    </aside>
  </div>
</template>
<script>
// Painel de filtros combináveis. `fields`: [{ key, label, type: select|multi|date|number, options }]
// `value`: filtros aplicados ({ [key]: valor }). Emite `apply` com o novo objeto (sem chaves vazias).
export default {
  props: {
    fields: { type: Array, required: true },
    value: { type: Object, default: () => ({}) },
    // Permite separar o botão (ex.: no header) dos chips (ex.: abaixo dele)
    showButton: { type: Boolean, default: true },
    showChips: { type: Boolean, default: true },
  },
  data() {
    return { open: false, draft: {} };
  },
  computed: {
    shownChips() {
      return this.showChips ? this.chips : [];
    },
    chips() {
      return this.fields
        .filter((f) => this.isFilled(this.value[f.key]))
        .map((f) => ({ key: f.key, text: `${f.label}: ${this.display(f, this.value[f.key])}` }));
    },
  },
  methods: {
    isFilled(v) {
      return Array.isArray(v) ? v.length > 0 : v !== undefined && v !== null && v !== "";
    },
    display(field, v) {
      const label = (x) => (field.options.find((o) => o.value === x) || {}).label || x;
      if (field.type === "select") return label(v);
      if (field.type === "multi") return v.map(label).join(", ");
      if (field.type === "date") return this.$moment(v).format("DD/MM/YYYY");
      return v;
    },
    emptyDraft() {
      const d = {};
      this.fields.forEach((f) => (d[f.key] = f.type === "multi" ? [] : ""));
      return d;
    },
    openPanel() {
      this.draft = { ...this.emptyDraft(), ...JSON.parse(JSON.stringify(this.value)) };
      this.open = true;
    },
    resetDraft() {
      this.draft = this.emptyDraft();
    },
    emitFilters(source) {
      const out = {};
      this.fields.forEach((f) => {
        if (this.isFilled(source[f.key])) out[f.key] = source[f.key];
      });
      this.$emit("apply", out);
    },
    apply() {
      this.emitFilters(this.draft);
      this.open = false;
    },
    remove(key) {
      this.emitFilters({ ...this.value, [key]: "" });
    },
    clearAll() {
      this.emitFilters({});
    },
  },
};
</script>
<style scoped>
.chip {
  font-size: 0.78rem;
  font-weight: 600;
  padding: 6px 10px;
}
.filter-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1040;
}
.filter-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 360px;
  max-width: 100vw;
  background: #fff;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.2s ease;
}
.filter-drawer--open {
  transform: translateX(0);
}
</style>
